import $ from 'jquery';

export default class PlayerChessIndicator {
  constructor($container, model) {
    this.model = model;
    this.$container = $container;

    // Check if the container is empty
    if (this.$container.children().length === 0) {
      // Create the player indicator structure with layers
      this.$indicator = $(`
        <div class="video-stack">
          <div class="overlay-top">
          <span class="material-icons-outlined clickable">chair</span>
          <div class="outline-chess-visitor"></div>
          </div>
          <div class="video-wrapper"></div>
          <div class="overlay-bottom">
            <img src="./textures/empty.png" alt="Empty seat">
          </div>
          <div class="speaking-indicator" style="display: none;">
            <span></span><span></span><span></span>
          </div>
          <div class="video-name">
            <span></span>
          </div>
        </div>
      `);

      // Append the indicator to the container
      this.$container.append(this.$indicator);
    } else {
      // Use the existing structure
      this.$indicator = this.$container.find('.video-stack');
      if (this.$indicator.length === 0) {
        // If there's no .video-stack, wrap the existing content
        this.$container.wrapInner('<div class="video-stack"></div>');
        this.$indicator = this.$container.find('.video-stack');

        // Add the overlay-top layer if it doesn't exist
        if (this.$indicator.find('.overlay-top').length === 0) {
          this.$indicator.append(`
            <div class="overlay-top">
              <span class="material-icons-outlined clickable">chair</span>
            </div>
          `);
        }

        // Add the video-wrapper layer if it doesn't exist
        if (this.$indicator.find('.video-wrapper').length === 0) {
          this.$indicator.append(`
            <div class="video-wrapper"></div>
          `);
        }

        // Add the overlay-bottom layer if it doesn't exist
        if (this.$indicator.find('.overlay-bottom').length === 0) {
          this.$indicator.append(`
            <div class="overlay-bottom">
              <img src="./textures/empty.png" alt="Empty seat">
            </div>
          `);
        }

        // Add the video-name layer if it doesn't exist
        if (this.$indicator.find('.video-name').length === 0) {
          this.$indicator.append(`
            <div class="video-name">
              <span></span>
            </div>
          `);
        }
      }
    }

    // Cache DOM elements
    this.$icon = this.$indicator.find('.overlay-top');
    this.$image = this.$indicator.find('.overlay-bottom');
    this.$video = this.$indicator.find('.video-wrapper');
    this.$name = this.$indicator.find('.video-name span');
    this.$speakingIndicator = this.$indicator.find('.speaking-indicator');
    this.$speakingIndicator.hide();

    // Initially show the empty state
    this.showEmpty();
  }

  showVideo(videoElement) {
    // Show the video wrapper
    this.$video.show();

    // Move the video element to this indicator's video wrapper
    this.$video.append(videoElement);

    // Style the video element
    videoElement.css({
      'width': '100%',
      'height': '100%',
      'object-fit': 'cover',
      'display': 'block'
    });

    // Hide other layers
    this.$icon.hide();
    this.$image.hide();
    this.setSpeakingIndicatorStatus(false);
  }

  showAvatar(avatarUrl, userId) {
    // Show image layer
    this.$image.show();
    //remove classes from image
    this.$image.find('img').removeClass();
    this.$image.find('img').addClass(`chat-img-dynamic-${userId}`);
    this.$image.find('img').attr('src', avatarUrl);

    // Hide other layers
    this.$icon.hide();
    this.$video.hide();
    this.setSpeakingIndicatorStatus(false);
  }

  showEmpty() {
    // Show icon layer
    this.$icon.show();
    // Hide other layers
    this.$image.hide();
    this.$video.hide();
    this.$speakingIndicator.hide();

  }

  // Helper method to check current state
  getCurrentState() {
    if (this.$icon.is(':visible')) return 'empty';
    if (this.$image.is(':visible')) return 'avatar';
    if (this.$video.is(':visible')) return 'video';
    return 'unknown';
  }

  // Method to handle click events
  onClick(callback) {
    this.$indicator.on('click', callback);
  }

  // Method to remove click handler
  offClick(callback) {
    this.$indicator.off('click', callback);
  }

  // Method to set player name
  setName(name) {
    this.$name.text(name || '');
  }


  showSpeakingIndicator() {
    this.$speakingIndicator.hide();
    this.setSpeakingIndicatorStatus(false);
    return;
    this.$speakingIndicator.show();
    this.$container.removeClass('speaking-outline--muted')
  }

  hideSpeakingIndicator() {
    this.$speakingIndicator.hide();
    this.$container.addClass('speaking-outline--muted')
  }

  setSpeakingIndicatorStatus(isActive) {
    return;
    this.$speakingIndicator.hide();
    this.$speakingIndicator.toggleClass('speaking-indicator--active', isActive)
    this.$container.toggleClass('speaking-outline', isActive)
  }
}
